import React, { useState } from "react";
import { Alert, Space, Typography } from "antd";
import ModalItem from "./ModalItem";
import ButtonItem from "./ButtonItem";

const { Text } = Typography;

const LIGA_LISR = "https://www.diputados.gob.mx/LeyesBiblio/pdf/LISR.pdf";

// Artículo 35 — maquinaria y equipo distintos a los del Artículo 34, por actividad
const ACTIVIDADES_ART35 = [
  { fraccion: "I", porcentaje: 5, texto: "Generación, conducción, transformación y distribución de electricidad; molienda de granos; producción de azúcar y sus derivados; fabricación de aceites comestibles; transporte marítimo, fluvial y lacustre." },
  { fraccion: "II", porcentaje: 6, texto: "Producción de metal obtenido en primer proceso; fabricación de productos de tabaco y derivados del carbón natural." },
  { fraccion: "III", porcentaje: 7, texto: "Fabricación de pulpa, papel y productos similares." },
  { fraccion: "IV", porcentaje: 8, texto: "Fabricación de vehículos de motor y sus partes; construcción de ferrocarriles y navíos; fabricación de productos de metal, de maquinaria y de instrumentos profesionales y científicos; elaboración de productos alimenticios y de bebidas, excepto granos, azúcar, aceites comestibles y derivados." },
  { fraccion: "V", porcentaje: 9, texto: "Curtido de piel y fabricación de artículos de piel; elaboración de productos químicos, petroquímicos y farmacobiológicos; fabricación de productos de caucho y de plástico; impresión y publicación gráfica." },
  { fraccion: "VI", porcentaje: 10, texto: "Transporte eléctrico; infraestructura fija para transporte, almacenamiento y procesamiento de hidrocarburos; plataformas y embarcaciones de perforación de pozos, y embarcaciones de procesamiento y almacenamiento de hidrocarburos." },
  { fraccion: "VII", porcentaje: 11, texto: "Fabricación, acabado, teñido y estampado de productos textiles, así como de prendas para el vestido." },
  { fraccion: "VIII", porcentaje: 12, texto: "Industria minera; construcción de aeronaves; transporte terrestre de carga y pasajeros." },
  { fraccion: "IX", porcentaje: 16, texto: "Transporte aéreo; transmisión de los servicios de comunicación proporcionados por telégrafos y por estaciones de radio y televisión." },
  { fraccion: "X", porcentaje: 20, texto: "Restaurantes." },
  { fraccion: "XI", porcentaje: 25, texto: "Industria de la construcción; agricultura, ganadería, silvicultura y pesca." },
  { fraccion: "XII", porcentaje: 35, texto: "Destinados directamente a la investigación de nuevos productos o desarrollo de tecnología en el país." },
  { fraccion: "XIII", porcentaje: 50, texto: "Manufactura, ensamble y transformación de componentes magnéticos para discos duros y tarjetas electrónicas para la industria de la computación." },
  { fraccion: "XIV", porcentaje: 10, texto: "Otras actividades no especificadas en este artículo." },
];

// Árbol de decisión — Artículo 34 (por tipo de bien) + rama a Artículo 35 (por actividad)
const ARBOL_DEPRECIACION = [
  {
    label: "Construcciones",
    pregunta: "¿El inmueble está declarado monumento arqueológico, artístico, histórico o patrimonial, con certificado de restauración del INAH o del INBA?",
    opciones: [
      { label: "Sí, cuenta con ese certificado", hoja: { porcentaje: 10, fraccion: "fracción I, inciso a)", texto: "Inmuebles declarados monumentos arqueológicos, artísticos, históricos o patrimoniales, con certificado de restauración del INAH o del INBA." } },
      { label: "No, es una construcción normal (incluye instalaciones, adiciones, reparaciones, mejoras y adaptaciones)", hoja: { porcentaje: 5, fraccion: "fracción I, inciso b)", texto: "Los demás casos, incluyendo instalaciones, adiciones, reparaciones, mejoras, adaptaciones, y construcciones en un lote minero." } },
    ],
  },
  {
    label: "Ferrocarriles",
    pregunta: "¿Qué tipo de bien de ferrocarril es?",
    opciones: [
      { label: "Bombas de suministro de combustible a trenes", hoja: { porcentaje: 3, fraccion: "fracción II, inciso a)", texto: "Bombas de suministro de combustible a trenes." } },
      { label: "Vías férreas", hoja: { porcentaje: 5, fraccion: "fracción II, inciso b)", texto: "Vías férreas." } },
      { label: "Carros de ferrocarril, locomotoras, armones y autoarmones", hoja: { porcentaje: 6, fraccion: "fracción II, inciso c)", texto: "Carros de ferrocarril, locomotoras, armones y autoarmones." } },
      { label: "Maquinaria niveladora de vías, desclavadoras, esmeriles, gatos de motor, removedora, insertadora y taladradora de durmientes", hoja: { porcentaje: 7, fraccion: "fracción II, inciso d)", texto: "Maquinaria niveladora de vías, desclavadoras, esmeriles para vías, gatos de motor para levantar la vía, removedora, insertadora y taladradora de durmientes." } },
      { label: "Equipo de comunicación, señalización y telemando", hoja: { porcentaje: 10, fraccion: "fracción II, inciso e)", texto: "Equipo de comunicación, señalización y telemando." } },
    ],
  },
  { label: "Mobiliario y equipo de oficina", hoja: { porcentaje: 10, fraccion: "fracción III", texto: "Mobiliario y equipo de oficina." } },
  { label: "Embarcaciones", hoja: { porcentaje: 6, fraccion: "fracción IV", texto: "Embarcaciones." } },
  {
    label: "Aviones",
    pregunta: "¿El avión está dedicado a la aerofumigación agrícola?",
    opciones: [
      { label: "Sí, aerofumigación agrícola", hoja: { porcentaje: 25, fraccion: "fracción V, inciso a)", texto: "Aviones dedicados a la aerofumigación agrícola." } },
      { label: "No, otro uso", hoja: { porcentaje: 10, fraccion: "fracción V, inciso b)", texto: "Los demás aviones." } },
    ],
  },
  { label: "Automóviles, autobuses, camiones de carga, tractocamiones, montacargas y remolques", hoja: { porcentaje: 25, fraccion: "fracción VI", texto: "Automóviles, autobuses, camiones de carga, tractocamiones, montacargas y remolques." } },
  { label: "Computadoras, servidores, impresoras y equipo de cómputo", hoja: { porcentaje: 30, fraccion: "fracción VII", texto: "Computadoras personales de escritorio y portátiles; servidores; impresoras, lectores ópticos, graficadores, lectores de código de barras, digitalizadores, unidades de almacenamiento externo y concentradores de redes de cómputo." } },
  { label: "Dados, troqueles, moldes, matrices y herramental", hoja: { porcentaje: 35, fraccion: "fracción VIII", texto: "Dados, troqueles, moldes, matrices y herramental." } },
  { label: "Semovientes y vegetales", hoja: { porcentaje: 100, fraccion: "fracción IX", texto: "Semovientes y vegetales." } },
  {
    label: "Comunicaciones telefónicas",
    pregunta: "¿Qué tipo de equipo de comunicación telefónica es?",
    opciones: [
      { label: "Torres de transmisión y cables (excepto fibra óptica)", hoja: { porcentaje: 5, fraccion: "fracción X, inciso a)", texto: "Torres de transmisión y cables, excepto los de fibra óptica." } },
      { label: "Sistemas de radio (microondas, torres de microondas, guías de onda)", hoja: { porcentaje: 8, fraccion: "fracción X, inciso b)", texto: "Sistemas de radio, incluyendo equipo de transmisión y manejo que utiliza el espectro radioeléctrico, como radiotransmisión de microonda digital o analógica, torres de microondas y guías de onda." } },
      { label: "Equipo de transmisión (multiplexores, concentradores, ruteadores)", hoja: { porcentaje: 10, fraccion: "fracción X, inciso c)", texto: "Equipo utilizado en la transmisión, como circuitos de la planta interna que no forman parte de la conmutación, incluyendo multiplexores, equipos concentradores y ruteadores." } },
      { label: "Equipo de central telefónica (conmutación no electromecánica)", hoja: { porcentaje: 25, fraccion: "fracción X, inciso d)", texto: "Equipo de la central telefónica destinado a la conmutación de llamadas de tecnología distinta a la electromecánica." } },
      { label: "Los demás equipos telefónicos", hoja: { porcentaje: 10, fraccion: "fracción X, inciso e)", texto: "Los demás equipos de comunicaciones telefónicas." } },
    ],
  },
  {
    label: "Comunicaciones satelitales",
    pregunta: "¿Es el segmento satelital en el espacio, o el equipo satelital en tierra?",
    opciones: [
      { label: "Segmento satelital en el espacio (satélite, transpondedores, antenas, monitoreo)", hoja: { porcentaje: 8, fraccion: "fracción XI, inciso a)", texto: "Segmento satelital en el espacio, incluyendo el cuerpo principal del satélite, los transpondedores, las antenas para transmisión y recepción de comunicaciones digitales y análogas, y el equipo de monitoreo en el satélite." } },
      { label: "Equipo satelital en tierra", hoja: { porcentaje: 10, fraccion: "fracción XI, inciso b)", texto: "Equipo satelital en tierra, incluyendo antenas para transmisión y recepción de comunicaciones digitales y análogas y el equipo para el monitoreo del satélite." } },
    ],
  },
  { label: "Adaptaciones para accesibilidad de personas con discapacidad", hoja: { porcentaje: 100, fraccion: "fracción XII", texto: "Adaptaciones a instalaciones que impliquen adiciones o mejoras al activo fijo, con la finalidad de facilitar el acceso y uso a personas con discapacidad." } },
  {
    label: "Maquinaria y equipo para energía renovable o cogeneración eficiente",
    hoja: {
      porcentaje: 100,
      fraccion: "fracción XIII",
      texto: "Maquinaria y equipo para la generación de energía proveniente de fuentes renovables o de sistemas de cogeneración de electricidad eficiente.",
      advertencia: "Requiere mantenerse en operación o funcionamiento un mínimo de 5 años; si se incumple ese plazo, debe cubrirse el impuesto correspondiente a la diferencia mediante declaraciones complementarias.",
    },
  },
  { label: "Bicicletas convencionales, bicicletas y motocicletas eléctricas", hoja: { porcentaje: 25, fraccion: "fracción XIV", texto: "Bicicletas convencionales, bicicletas y motocicletas cuya propulsión sea a través de baterías eléctricas recargables." } },
  { label: "Derecho de usufructo sobre un bien inmueble", hoja: { porcentaje: 5, fraccion: "fracción XV", texto: "Derecho de usufructo constituido sobre un bien inmueble." } },
  {
    label: "Otra maquinaria y equipo (según la actividad del negocio)",
    pregunta: "¿En qué actividad se utiliza esta maquinaria o equipo? (Artículo 35 — aplica cuando el bien no está listado en las categorías anteriores)",
    opciones: ACTIVIDADES_ART35.map((a) => ({
      label: a.texto,
      hoja: { porcentaje: a.porcentaje, fraccion: `fracción ${a.fraccion}`, texto: a.texto, articulo: "Artículo 35" },
    })),
  },
];

const RAIZ = {
  pregunta: "¿Qué tipo de bien es el que quieres depreciar?",
  opciones: ARBOL_DEPRECIACION.map((categoria) =>
    categoria.hoja
      ? { label: categoria.label, hoja: categoria.hoja }
      : { label: categoria.label, siguiente: categoria }
  ),
};

const AsistenteDepreciacionLISR = ({ visible, onClose, onAplicar }) => {
  const [pila, setPila] = useState([RAIZ]);
  const [migas, setMigas] = useState([]);
  const [resultado, setResultado] = useState(null);

  const reiniciar = () => {
    setPila([RAIZ]);
    setMigas([]);
    setResultado(null);
  };

  const cerrar = () => {
    reiniciar();
    onClose();
  };

  const elegirOpcion = (opcion) => {
    if (opcion.siguiente) {
      setPila([...pila, opcion.siguiente]);
      setMigas([...migas, opcion.label]);
    } else {
      setMigas([...migas, opcion.label]);
      setResultado(opcion.hoja);
    }
  };

  const regresar = () => {
    if (resultado) {
      setResultado(null);
      setMigas(migas.slice(0, -1));
      return;
    }
    if (pila.length > 1) {
      setPila(pila.slice(0, -1));
      setMigas(migas.slice(0, -1));
    }
  };

  const aplicar = () => {
    onAplicar({ porcentaje: resultado.porcentaje, metodo: 1 });
    cerrar();
  };

  const nodoActual = pila[pila.length - 1];

  return (
    <ModalItem
      title="Asistente de Depreciación (Ley del ISR)"
      visible={visible}
      spinning={false}
      onCancel={cerrar}
      paddingTop
      width={640}
    >
      {migas.length > 0 && (
        <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
          {migas.join(" > ")}
        </Text>
      )}

      {!resultado && (
        <>
          <Text strong style={{ display: "block", marginBottom: 12 }}>
            {nodoActual.pregunta}
          </Text>
          <Space direction="vertical" style={{ width: "100%" }}>
            {nodoActual.opciones.map((opcion) => (
              <ButtonItem
                key={opcion.label}
                blanco
                block
                style={{ height: "auto", whiteSpace: "normal", textAlign: "left", padding: "8px 12px" }}
                onClick={() => elegirOpcion(opcion)}
              >
                {opcion.label}
              </ButtonItem>
            ))}
          </Space>
        </>
      )}

      {resultado && (
        <>
          <Alert
            type="success"
            showIcon
            style={{ marginBottom: 12 }}
            message={<span style={{ fontSize: 20 }}>{resultado.porcentaje}% anual</span>}
            description={
              <span>
                <strong>{resultado.articulo || "Artículo 34"}, {resultado.fraccion}.</strong> {resultado.texto}
              </span>
            }
          />
          {resultado.advertencia && (
            <Alert type="warning" showIcon style={{ marginBottom: 12 }} message={resultado.advertencia} />
          )}
          <a href={LIGA_LISR} target="_blank" rel="noreferrer">
            Ver Ley del ISR (PDF)
          </a>
        </>
      )}

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
        <Space>
          {(pila.length > 1 || resultado) && (
            <ButtonItem blanco onClick={regresar}>Regresar</ButtonItem>
          )}
          {migas.length > 0 && (
            <ButtonItem blanco onClick={reiniciar}>Empezar de nuevo</ButtonItem>
          )}
        </Space>
        {resultado ? (
          <ButtonItem type="primary" onClick={aplicar}>Usar este %</ButtonItem>
        ) : (
          <ButtonItem blanco onClick={cerrar}>Cerrar</ButtonItem>
        )}
      </div>
    </ModalItem>
  );
};

export default AsistenteDepreciacionLISR;
